module.exports = __webpack_public_path__ + "img/collage.f615edfe.jpg";